import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {  FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
library.add(fas, fab, far);
@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
  FontAwesomeModule
  ],
  exports: [
    FontAwesomeModule
  ]
})
export class IconsModule {
//   constructor( biblioteca : FaIconLibrary){
//     biblioteca.addIconPacks( fas, far,fab);
//  }
}